(() => {
  let text = {};
  try {
    text = JSON.parse(document.getElementById('vg-navigation-text')?.textContent || '{}');
    // JSON script contents are raw text, so decode the HTML entities produced by Liquid t once.
    const entities = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: '\u00a0' };
    Object.keys(text).forEach(key => {
      text[key] = String(text[key]).replace(/&(#(?:x[0-9a-f]+|[0-9]+)|amp|lt|gt|quot|apos|nbsp);/gi, (entity, name) => {
        if (name[0] !== '#') return entities[name.toLowerCase()] || entity;
        const code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : Number(name.slice(1));
        return code > 0 && code <= 0x10ffff ? String.fromCodePoint(code) : entity;
      });
    });
  } catch (_) {}
  const message = (key, fallback, values = {}) => (text[key] || fallback).replace(/\{\{\s*(\w+)\s*\}\}|__(\w+)__/g, (_, braceName, markerName) => values[braceName || markerName] ?? '');
  const localizedUrl = url => {
    const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
    return root + String(url).replace(/^\/[a-z]{2}(?:-[A-Z]{2})?(?=\/products\/)/, '');
  };
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const savedKey = 'vargsten:saved-rings';
  let saved = [];
  try {
    const stored = JSON.parse(localStorage.getItem(savedKey) || '[]');
    if (Array.isArray(stored)) saved = stored.filter(item => item && /^\//.test(item.url) && !/^\/\//.test(item.url));
  } catch (_) {}

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function icon(name) {
    const node = element('span', 'material-symbols-outlined vg-icon', name);
    node.setAttribute('aria-hidden', 'true');
    return node;
  }

  function plainText(html) {
    return new DOMParser().parseFromString(html || '', 'text/html').body.textContent.trim();
  }

  function safeImage(url) {
    try {
      const parsed = new URL(url, location.origin);
      return ['https:', 'http:'].includes(parsed.protocol) ? parsed.href : '';
    } catch (_) { return ''; }
  }

  function openDialog(dialog) {
    if (!dialog || dialog.open) return;
    document.querySelectorAll('[data-vg-menu]').forEach(menu => { menu.open = false; });
    dialog.showModal();
  }

  function renderSaved() {
    const visibleSaved = saved.filter(item => !/\/products\/personalized-wood-ring-box(?:[/?#]|$)/.test(item.url));
    document.querySelectorAll('[data-vg-save]').forEach(button => {
      const active = saved.some(item => item.id === button.dataset.productId);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', message(active ? 'unsave' : 'save', active ? 'Unsave {{ title }}' : 'Save {{ title }}', { title: button.dataset.title }));
      button.title = active ? message('remove_saved', 'Remove from saved rings') : message('save_ring', 'Save ring');
    });
    const list = document.querySelector('[data-vg-saved-list]');
    if (!list) return;
    list.replaceChildren();
    if (!visibleSaved.length) {
      list.append(element('p', 'vg-empty', message('empty_saved', 'No saved rings yet.')));
      return;
    }
    visibleSaved.forEach(item => {
      const row = element('div', 'vg-saved-item');
      const image = element('img');
      image.src = safeImage(item.image);
      image.alt = item.title;
      image.width = 80;
      image.height = 100;
      const link = element('a', '', item.title);
      link.href = localizedUrl(item.url);
      const remove = element('button');
      remove.type = 'button';
      remove.dataset.vgUnsave = item.id;
      remove.setAttribute('aria-label', message('remove', 'Remove {{ title }}', { title: item.title }));
      remove.append(icon('close'));
      row.append(image, link, remove);
      list.append(row);
    });
  }

  function persistSaved() {
    try { localStorage.setItem(savedKey, JSON.stringify(saved)); } catch (_) {}
    renderSaved();
  }

  // Keep the existing product and cart integrations working with the shared header.
  window.mjUpdateCartBadge = count => {
    count = Math.max(0, Number(count) || 0);
    document.querySelectorAll('.vg-cart-count, .mj-cart-badge').forEach(badge => {
      badge.textContent = count;
    });
    document.querySelectorAll('[data-vg-cart]').forEach(link => {
      link.setAttribute('aria-label', message(count === 1 ? 'cart_label_one' : 'cart_label', count === 1 ? 'Shopping bag, {{ count }} item' : 'Shopping bag, {{ count }} items', { count }));
    });
  };
  async function refreshCartCount() {
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
      if (response.ok) window.mjUpdateCartBadge((await response.json()).item_count);
    } catch (_) {}
  }
  document.addEventListener('mj:cart:added', refreshCartCount);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (typeof event.cartData?.item_count === 'number') window.mjUpdateCartBadge(event.cartData.item_count);
      else refreshCartCount();
    });
  }
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCartCount(); });

  function initCarousel(root) {
    if (root.dataset.vgCarouselReady || root.hidden) return;
    const track = root.querySelector('[data-vg-track]');
    const previous = root.querySelector('[data-vg-prev]');
    const next = root.querySelector('[data-vg-next]');
    if (!track || !previous || !next) return;
    root.dataset.vgCarouselReady = 'true';
    const controller = new AbortController();
    root.vgCleanup = () => { controller.abort(); observer.disconnect(); };
    const options = { signal: controller.signal };
    const update = () => {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const advance = direction => {
      const first = track.firstElementChild;
      const step = first ? first.getBoundingClientRect().width + 10 : track.clientWidth * .8;
      track.scrollBy({ left: direction * step, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    };
    previous.addEventListener('click', () => advance(-1), options);
    next.addEventListener('click', () => advance(1), options);
    track.addEventListener('scroll', update, { ...options, passive: true });
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        advance(event.key === 'ArrowRight' ? 1 : -1);
      }
    }, options);
    let drag = null;
    let moved = false;
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { x: event.clientX, scroll: track.scrollLeft };
      moved = false;
    }, options);
    window.addEventListener('pointermove', event => {
      if (!drag) return;
      const delta = drag.x - event.clientX;
      if (Math.abs(delta) > 6) {
        moved = true;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = drag.scroll + delta;
      }
    }, options);
    window.addEventListener('pointerup', () => {
      drag = null;
      track.style.scrollSnapType = '';
    }, options);
    track.addEventListener('dragstart', event => event.preventDefault(), options);
    track.addEventListener('click', event => {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }, { ...options, capture: true });
    const observer = new ResizeObserver(update);
    observer.observe(track);
    update();
  }

  function initCommunity(root) {
    if (root.dataset.vgCommunityReady) return;
    root.dataset.vgCommunityReady = 'true';
    const reviews = [];
    const seen = new Set();
    root.querySelectorAll('[data-vg-review-source]').forEach(source => {
      const data = source.content.querySelector('[data-json]');
      if (!data) return;
      let records;
      try { records = JSON.parse(data.getAttribute('data-json')); } catch (_) { return; }
      if (!Array.isArray(records)) return;
      records.forEach(record => {
        const body = plainText(record.body_html);
        const key = record.uuid || [record.reviewer_name, body].join('|');
        if (!body || seen.has(key)) return;
        seen.add(key);
        const rating = Number(record.rating);
        if (!Number.isFinite(rating) || rating < 1 || rating > 5) return;
        const date = new Date((record.created_at || '').replace(' UTC', 'Z').replace(' ', 'T'));
        reviews.push({
          name: (record.reviewer_name || '').trim() || message('anonymous', 'Anonymous'),
          title: plainText(record.title),
          body,
          rating: Math.round(rating),
          verified: record.verified_buyer === true,
          date: Number.isNaN(date.getTime()) ? null : date,
          photos: (record.pictures_urls || []).map(photo => safeImage(photo.original || photo.compact)).filter(Boolean),
          url: source.dataset.productUrl,
          product: source.dataset.productTitle
        });
      });
    });
    reviews.sort((a, b) => (b.date?.getTime() || 0) - (a.date?.getTime() || 0));
    const limit = Number(root.dataset.reviewLimit) || 12;
    const reviewTrack = root.querySelector('[data-vg-review-track]');
    const photoTrack = root.querySelector('[data-vg-photo-track]');
    const dialog = root.querySelector('[data-vg-review-dialog]');
    const stars = review => '\u2605'.repeat(review.rating) + '\u2606'.repeat(5 - review.rating);

    function showReview(review, photo) {
      dialog.querySelector('[data-vg-review-author]').textContent = review.name;
      dialog.querySelector('[data-vg-review-body]').textContent = review.body;
      const image = dialog.querySelector('[data-vg-review-photo]');
      image.hidden = !photo;
      if (photo) {
        image.src = photo;
        image.alt = message('customer_photo', 'Customer photo of {{ title }}', { title: review.product });
      } else image.removeAttribute('src');
      const product = dialog.querySelector('[data-vg-review-product]');
      product.href = review.url;
      product.textContent = message('view_product', 'View {{ title }}', { title: review.product.split(' - ')[0] });
      openDialog(dialog);
    }

    reviews.slice(0, limit).forEach(review => {
      const card = element('article', 'vg-review');
      const top = element('div', 'vg-review-top');
      const rating = element('span', 'vg-review-stars', stars(review));
      rating.setAttribute('aria-label', message('stars', '{{ count }} out of 5 stars', { count: review.rating }));
      top.append(rating, document.createTextNode(' - ' + review.name));
      card.append(top);
      if (review.title) card.append(element('h3', '', review.title));
      card.append(element('p', 'vg-review-body', review.body));
      if (review.body.length > 115) {
        const more = element('button', 'vg-review-read', message('read_more', 'Read more'));
        more.type = 'button';
        more.setAttribute('aria-label', message('read_review', 'Read {{ name }}’s full review', { name: review.name }));
        more.addEventListener('click', () => showReview(review));
        card.append(more);
      }
      const footer = element('div', 'vg-review-footer');
      const source = element('a', '', 'Judge.me');
      source.href = review.url + '#judgeme_product_reviews';
      footer.append(document.createTextNode(review.verified ? message('verified_buyer', 'Verified buyer · ') : message('review_via', 'Review via ')), source);
      if (review.date) {
        const date = element('time', '', review.date.toLocaleDateString(document.documentElement.lang || 'en', { month: 'long', day: 'numeric', year: 'numeric' }));
        date.dateTime = review.date.toISOString();
        footer.append(document.createElement('br'), date);
      }
      card.append(footer);
      reviewTrack.append(card);
    });

    const photoReviews = reviews.filter(review => review.photos.length).slice(0, limit);
    photoReviews.forEach(review => {
      const button = element('button', 'vg-photo');
      button.type = 'button';
      button.setAttribute('aria-label', message('view_photo', 'View {{ name }}’s ring photo and review', { name: review.name }));
      const media = element('span', 'vg-photo-image');
      const image = element('img');
      image.src = review.photos[0];
      image.alt = message('customer_photo', 'Customer photo of {{ title }}', { title: review.product });
      image.loading = 'lazy';
      image.width = 600;
      image.height = 800;
      media.append(image);
      button.append(media, element('span', 'vg-photo-caption', review.name));
      button.addEventListener('click', () => showReview(review, review.photos[0]));
      photoTrack.append(button);
    });
    root.querySelector('[data-vg-reviews]').hidden = !reviews.length;
    root.querySelector('[data-vg-photos]').hidden = !photoReviews.length;
    root.querySelectorAll('[data-vg-carousel]').forEach(initCarousel);
  }

  function initHeader() {
    const header = document.querySelector('[data-vg-header]');
    if (!header || header.dataset.vgHeaderReady) return;
    header.dataset.vgHeaderReady = 'true';
    const update = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    window.addEventListener('scroll', update, { passive: true });
    update();
    const hoverMenu = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
    header.querySelectorAll('[data-vg-menu]').forEach(menu => {
      let closeTimer;
      menu.addEventListener('pointerenter', event => {
        clearTimeout(closeTimer);
        if (hoverMenu.matches && event.pointerType === 'mouse') menu.open = true;
      });
      menu.addEventListener('pointerleave', event => {
        if (!hoverMenu.matches || event.pointerType !== 'mouse') return;
        // Allow the pointer to cross the small gap between SHOP and its panel.
        closeTimer = setTimeout(() => {
          if (!menu.contains(document.activeElement)) menu.open = false;
        }, 180);
      });
      menu.addEventListener('focusout', event => {
        if (!menu.contains(event.relatedTarget) && !menu.matches(':hover')) {
          clearTimeout(closeTimer);
          menu.open = false;
        }
      });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-vg-community]').forEach(initCommunity);
    scope.querySelectorAll('[data-vg-carousel]').forEach(initCarousel);
    initHeader();
    renderSaved();
    scope.querySelectorAll('[data-vg-video]').forEach(button => {
      if (button.dataset.vgVideoReady) return;
      button.dataset.vgVideoReady = 'true';
      const video = button.closest('section').querySelector('video');
      if (!video) return;
      const update = () => {
        button.setAttribute('aria-label', video.paused ? message('play_video', 'Play video') : message('pause_video', 'Pause video'));
        button.title = video.paused ? message('play_video', 'Play video') : message('pause_video', 'Pause video');
        button.querySelector('[data-vg-play]').hidden = !video.paused;
        button.querySelector('[data-vg-pause]').hidden = video.paused;
      };
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      if (reducedMotion.matches) video.pause();
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => update());
        else video.pause();
      });
      update();
    });
  }

  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-vg-open]');
    if (opener) openDialog(document.getElementById(opener.dataset.vgOpen));
    const close = event.target.closest('[data-vg-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const save = event.target.closest('[data-vg-save]');
    if (save) {
      const id = save.dataset.productId;
      if (saved.some(item => item.id === id)) saved = saved.filter(item => item.id !== id);
      else saved.push({ id, title: save.dataset.title, url: save.dataset.url, image: save.dataset.image });
      persistSaved();
    }
    const remove = event.target.closest('[data-vg-unsave]');
    if (remove) {
      saved = saved.filter(item => item.id !== remove.dataset.vgUnsave);
      persistSaved();
    }
    document.querySelectorAll('[data-vg-menu][open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('[data-vg-close-menu]')) {
        menu.open = false;
        if (event.target.closest('[data-vg-close-menu]')) menu.querySelector('summary').focus();
      }
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-vg-menu][open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('vg:content:updated', renderSaved);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-vg-carousel]').forEach(root => root.vgCleanup?.());
  });
  init(document);
})();
